// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#customer-facing mat-card {
  margin: 0;
  padding: 0;
  box-shadow: none;
}
#customer-facing mat-card .FROexi-chat-content {
  justify-content: space-between;
}
#customer-facing mat-card mat-card-content {
  padding: 0;
  height: calc(100dvh - 3rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
#customer-facing mat-card mat-card-content .user-information {
  display: flex;
  justify-content: space-between;
  background-color: rgba(192, 192, 192, 0.2705882353);
  padding: 0.5em 0.5em 0.5em 0.5em;
  border-radius: 20px;
}
#customer-facing mat-card mat-card-content .froexi-chat-design {
  display: flex;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-top: 0.75rem;
  padding-bottom: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  height: 80%;
  background-color: #F3F4F6;
  border-radius: 20px;
}
#customer-facing .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

#backoffice mat-card mat-card-content {
  display: flex;
  gap: 1rem;
}
#backoffice mat-card mat-card-content aside {
  width: 22rem;
}
#backoffice mat-card mat-card-content .backoffice__chat {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  border-width: 2px;
  border-left-style: solid;
  border-color: #eeeef8;
  padding: 0.5em;
}
#backoffice mat-card mat-card-content .backoffice__chat .message_design {
  overflow-y: auto;
  height: calc(100vh - 19rem);
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
#backoffice .backoffice-own-reception-message {
  background-color: #2563EB;
  color: #ffffff;
}
#backoffice .backoffice-other-reception-message {
  background-color: #D1D5DB;
  color: #4B5563;
}

#FROhok {
  margin-top: 4rem;
}
#FROhok mat-card mat-card-content {
  gap: 1rem;
}
#FROhok mat-card mat-card-content .FROhok__chat {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100dvh - 7.5rem);
  min-height: 0;
  border-width: 2px;
  border-left-style: solid;
  border-color: #eeeef8;
  padding: 0.5em;
}
#FROhok mat-card mat-card-content .FROhok__chat .message_design {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
@media (max-width: 766px) {
  #FROhok mat-card mat-card-content .aside {
    width: 100% !important;
  }
  #FROhok mat-card mat-card-content .FROhok__chat {
    height: 73vh;
  }
}
#FROhok .FROhok-chat {
  width: 100%;
}
#FROhok .first-unread .left-message::before {
  content: "Új üzenetek";
  text-align: center;
  border-bottom: 1px solid #2563EB;
  padding-inline: 12rem;
  color: #2563EB;
  font-size: 0.875rem;
  font-weight: 500;
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.chat-message {
  display: flex;
  flex-direction: column;
}
.chat-message .left-message {
  display: flex;
  align-items: flex-end;
  margin: 0.25rem;
  position: relative;
}
.chat-message .left-message .left-message-tooltip {
  display: flex;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  flex-direction: column;
  order: 2;
  align-items: flex-start;
  max-width: 20rem;
}
.chat-message .left-message .left-message-design {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 20px;
  border-bottom-left-radius: 0;
  width: 100%;
  color: #4B5563;
  overflow-wrap: break-word;
  background-color: #D1D5DB;
}
.chat-message .right-message {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin: 0.25rem;
}
.chat-message .right-message .right-message-toolip {
  display: flex;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  flex-direction: column;
  order: 1;
  align-items: flex-end;
  max-width: 20rem;
}
.chat-message .right-message .right-message-design {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 20px;
  border-bottom-right-radius: 0;
  width: 100%;
  color: #ffffff;
  overflow-wrap: break-word;
  background-color: #2563EB;
}

.backoffice-message {
  position: fixed;
  display: flex;
  bottom: 2rem;
  right: 0;
  left: 33.5rem;
}

.message {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 1em;
}

.typing-indicator {
  flex-basis: 100%;
  margin: 0 0.5rem 0.15rem 0.5rem;
  min-height: 1rem;
  color: #6b7280;
  font-size: 0.8125rem;
}

.reception-sender-name {
  display: block;
  font-size: 0.7rem;
  color: #9ca3af;
  margin-top: 0.15rem;
  font-style: italic;
}

.read-receipt {
  display: block;
  text-align: right;
  font-size: 0.7rem;
  color: #9ca3af;
  margin-top: 0.15rem;
}

.message-input-wrapper {
  position: relative;
  flex-grow: 1;
  gap: 1rem;
  margin: 0.5rem;
  border-radius: 20px;
}
.message-input-wrapper .message-input-buttons {
  position: absolute;
  display: flex;
  align-items: center;
  right: 0;
  top: 0;
  bottom: 0;
}
.message-input-wrapper input {
  border-radius: 20px;
  background-color: rgb(229, 231, 235);
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.25rem;
  color: rgb(75, 85, 99);
  width: 100%;
}

.button-for-message {
  margin: auto;
  background-color: #41c300;
  border-color: #41c300 !important;
  color: white;
  height: 48px;
  width: 64px;
  border-radius: 20px;
  font-size: 25px;
}

.button-for-message:hover {
  background-color: #3bb300;
  border-color: #3bb300 !important;
}

aside {
  height: calc(100dvh - 7.6rem);
  height: auto;
}

.aside-title {
  font-size: 16px;
  border: 2px solid #0e0d21;
  font-weight: 500;
  margin-top: auto;
  border-width: 2px;
  padding: 0.5em 1em 0.5em 1em;
  margin-bottom: 0.7em;
  border-radius: 20px;
  text-align: center;
}

.chat-rooms {
  background-color: white;
  border-style: solid;
  border-color: #eeeef8;
  border-width: 2px;
  padding: 0.5em 1em 0.5em 1em;
  margin-bottom: 1em;
  border-radius: 20px;
  margin-right: 1em;
}

.active-chat-rooms {
  background-color: #eeeef8;
  border-width: 2px;
  padding: 0.5em 1em 0.5em 1em;
  margin-bottom: 1em;
  margin-top: 0.75rem;
  border-radius: 20px;
}

.chat-rooms-title {
  color: black;
  font-size: 16px;
  font-weight: 500;
  margin-top: auto;
  margin-bottom: auto;
}

.mat-mdc-chat-start {
  background-color: #ffffff;
  color: #565656;
  border-style: solid !important;
  border-color: #565656 !important;
  border-width: 2px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 36px !important;
  padding: 0 16px !important;
  font-family: var(--mdc-typography-button-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));
}

.center-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.grey-button {
  background-color: grey;
  color: white;
}

.user-name {
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 0.5em;
}

.hidden-radio {
  display: none;
}

.active-chat-rooms {
  background-color: #e5e7eb;
  cursor: pointer;
}

.hidden-radio:checked + .active-chat-rooms {
  background-color: #2563eb;
  color: white;
}

.hidden-radio:checked + .active-chat-rooms .chat-rooms-title {
  color: white;
  /* Aktív állapotban a kívánt szín */
}

.hidden-radio:checked + .active-chat-rooms .chat-rooms-icon {
  color: white;
  /* Aktív állapotban a kívánt szín */
}

.active-chat-rooms:hover {
  background-color: #f0f0f0;
  /* Hover szín */
}

hr {
  border: none;
  height: 1px;
  background-color: #333;
  /* sötétszürke */
  margin: 10px 0;
  /* opcionális, távolság a többi elemtől */
}

.selectedRoomByIndexFrohok:hover {
  cursor: pointer;
  background-color: hsl(0, 0%, 85%);
}

/* csak 767px felett látszik */
.desktop-rooms {
  display: block;
}

.mobile-rooms {
  display: none;
}

@media (max-width: 767px) {
  .desktop-rooms {
    display: none;
  }
  .mobile-rooms {
    display: block;
  }
  .mat-mdc-card-content {
    padding: 0px;
  }
  .desktop-users {
    display: none;
  }
  .mobile-users {
    display: block;
  }
  .aside-title {
    display: none;
  }
}
.mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix {
  padding-right: 16px;
  padding-left: 16px;
}

.mobile-users {
  display: none;
}

.chat-room-label {
  display: flex;
  justify-content: space-between;
  /* név balra, badge jobbra */
  align-items: center;
}

.room-name {
  flex: 1;
  /* szöveg balra tapad, badge jobbra */
}

/* A piros kör */
.badge {
  width: 30px;
  height: 30px;
  background: #e10600;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 12px;
  line-height: 1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  -webkit-user-select: none;
          user-select: none;
  margin-left: 8px;
  /* kis távolság a szövegtől */
}

.button-for-group-members {
  margin: auto;
  background-color: #3f51b5;
  border-color: #3f51b5 !important;
  color: white;
  height: 56px;
  width: 56px;
  border-radius: 20px;
  font-size: 33px;
  float: inline-end;
}

.hr-mobile {
  border: none;
  height: 1px;
  background-color: #333;
  margin: 0px;
}

.user-group-dialog .mat-dialog-container {
  padding: 1em !important;
}

.not-active-chat-wrapper {
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  padding: 3em;
  margin-bottom: 2em;
  text-align: center;
  /* Flexbox a középre igazításhoz */
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: -3em;
}

.not-active-chat-title {
  font-weight: 600;
  font-size: 20px;
}

.not-active-chat-icon {
  color: #ACA100;
}

/* asside scroll */
.scrollable-container-active {
  height: 45vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

/* asside scroll */
.scrollable-container-inactive {
  height: 20vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

.subtitle-padding {
  margin-left: 2.5em;
  display: inline-flex;
  margin-bottom: 0em;
}

.alert-icon-size {
  font-size: 42px;
}

.warning-icon {
  color: #ffca28;
}

.subtitle-padding {
  display: inline-flex;
  align-items: center;
  margin-bottom: 0em;
  margin-top: -2em;
}

.mat-badge-mobile {
  background-color: #ff4081;
  border-radius: 50%;
  margin-left: 0.5rem;
  color: white;
  padding: 2px 6px 2px 2px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
